import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CommonErrors, FormControl, Page, Group, Layout, Button, Grid, ExcelUpload } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_INSC_FORM,
    SF_RGST_VRFN_RSLT,
    SG_GRID_INSC_ATCM_LIST,
    SG_GRID_INSC_ATCM_VIEW_LIST,
} from "@/tz/go/egaz/osci/lpco/jntinsc/services/OsciJntinscService";

/*
 * Save Register Joint Exam Appointment Results
 * !== 합동검사 검사 결과 등록 화면 ==!
 */
export const OSCI0301003S = (props: any) => {
    /**
     * Page Unique identifier !== 화면 고유 식별자 ==!
     * Page Title !== 페이지 타이틀 ==!
     */
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { close, postMessage, getParams } = usePopup();
    const params = getParams(); // 부모창에서 전달된 Parameter
    const { paramData, callbackFn, viewOnly = false } = props;

    let errmsg: any;

    const [prcssStatCd, setPrcssStatCd] = useState(""); // Company Processing State Code !== 업체_처리_상태_코드 ==! */
    const [atcmList, setAtcmList] = useState(comnUtils.getGridData([]));
    const [atcmVisible, setAtcmVisible] = useState(false);
    const [sbmtVisible, setSbmtVisible] = useState(false);

    const [excludeAuditCode, setExcludeAuditCode] = useState<any[]>(["AP", "RS"]);

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    const { getResource, updateResource } = useResource({
        defaultSchema: [
            { area: "orgCd" }, // 기관(OGA) 코드 조회 팝업
            { area: "comnCd", comnCd: "OSC0131" } /* Audit State Code !== 심사 상태 코드 ==! */,
        ],
    });

    const form = {
        bkngInfo: useForm({
            defaultSchema: SF_SCHEMA_INSC_FORM,
            defaultValues: {
                tansadNo: paramData?.tansadNo,
                cstmOfceCd: paramData?.cstmOfceCd,
                tansadYy: paramData?.tansadYy,
                tansadSrno: paramData?.tansadSrno,
                reffNo: paramData?.reffNo,
                reffTin: paramData?.reffTin,
                reffYy: paramData?.reffYy,
                reffSrno: paramData?.reffSrno,
                bkngRqstDt: paramData?.bkngRqstDt,
                blNo: paramData?.blNo,
                prcsStatCd: paramData?.prcsStatCd,
            },
        }),
        bkngVrfnRslt: useForm({
            defaultSchema: SF_RGST_VRFN_RSLT,
        }),
    };

    const grid = {
        // Attachment Files List !== 첨부문서 목록 ==!
        jntInscAtcm: useGrid({
            defaultSchema: viewOnly ? SG_GRID_INSC_ATCM_VIEW_LIST : SG_GRID_INSC_ATCM_LIST,
        }),
    };

    const render = {
        grid_jntInscAtcmLst: {
            head: {},
            cell: {
                atcdFile: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const atcmId = rowValues.atcmId;
                    return (
                        <>
                            {atcmId && (
                                <FormControl type="file" bsopClsfCd="OSC" required={true} value={rowValues.atcdFile} />
                            )}
                        </>
                    );
                },
            },
            edit: {
                atcdFile: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const atcmId = rowValues.atcmId;
                    return (
                        <>
                            {atcmId && (
                                <FormControl type="file" bsopClsfCd="OSC" required={true} value={rowValues.atcdFile} />
                            )}
                        </>
                    );
                },
            },
            checkbox: (row: any) => {
                return true;
            },
        },
    };

    const fetch = {
        getBkngAppAprvInfo: useFetch({
            api: (data) => APIS.getBkngAppAprvInfo({ tansadNo: data }),
            onSuccess: (data) => {
                if (data.appAprvInfo!) {
                    if (data.appAprvInfo.content.prcssStatCd!) {
                        setSbmtVisible(true);
                    }
                    form.bkngVrfnRslt.setValues(data.appAprvInfo.content);
                    form.bkngVrfnRslt.setValue("prcssRsnCn", data.appAprvInfo.content.prcssRsnCn);

                    // 첨부파일 목록 조회
                    handler.getInscAtcmList();
                }
                let bkngPrcsStatCd = form.bkngInfo.getValue("prcsStatCd");

                setExcludeAuditCode([...APIS.getExcludeAuditRsltCdList("IP", "")]);
            },
            onError: (error) => {
                errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        getInscAtcmList: useFetch({
            api: (page = grid.jntInscAtcm.page) => {
                console.log(paramData?.tansadNo);
                return APIS.getInscAtcmList({ tansadNo: paramData?.tansadNo }, page, grid.jntInscAtcm.size);
            },
            key: [grid.jntInscAtcm.page, grid.jntInscAtcm.size],
            onSuccess: (data) => {
                if (data.atcmList.content! && data.atcmList.content.length > 0) {
                    setAtcmList(comnUtils.getGridData(data.atcmList.content || []));
                    setAtcmVisible(true);
                } else {
                    if ("IP" == form.bkngVrfnRslt.getValue("prcssStatCd")) {
                        setAtcmList(comnUtils.getGridData([]));
                        setAtcmVisible(true);
                    }
                }
            },
            onError: () => {},
            showToast: false,
        }),
        saveBkngAppAprvRslt: useFetch({
            api: (data) => {
                return APIS.saveBkngAppAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        handler.setInit();
                        modal.postMessage({ rslt: "save" });
                    },
                    onClose: () => {
                        handler.setInit();
                    },
                });
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        sbmtBkngAppAprvRslt: useFetch({
            api: (data) => {
                return APIS.sbmtBkngAppAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        modal.postMessage({ rslt: "sbmt" });
                        callbackFn(data);
                    },
                    onClose: () => {
                        modal.postMessage({ rslt: "sbmt" });
                        callbackFn(data);
                    },
                });
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
    };

    const handler = {
        setInit: async () => {
            if (viewOnly) {
                form.bkngVrfnRslt.setEditable(false);
            }
            await handler.getBkngAppAprvInfo();
        },
        getBkngAppAprvInfo: async () => {
            fetch.getBkngAppAprvInfo.fetch(paramData.tansadNo);
        },
        getInscAtcmList: (page: number = 0) => {
            grid.jntInscAtcm.setPage(page);
            fetch.getInscAtcmList.fetch(page);
        },
        click_Btn_AddGridList: () => {
            grid.jntInscAtcm.addRow();
        },
        click_Btn_DeleteGridList: () => {
            const seltList: any[] = grid.jntInscAtcm.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }
            grid.jntInscAtcm.deleteRow("checkbox");
        },
        validateRgstVrfnRslt: async (type: any) => {
            const chkRslt = await form.bkngVrfnRslt.validate();

            const inscAtcmList = grid.jntInscAtcm.getData();

            const atcmErrResult = grid.jntInscAtcm.validate() || {};
            if (atcmErrResult.errors?.length > 0) {
                modal.openModal({
                    content: <CommonErrors {...atcmErrResult} />,
                    size: "lg",
                    draggable: true,
                });
                return;
            }

            if (chkRslt) {
                form.bkngVrfnRslt.setValue("tansadNo", form.bkngInfo.getValue("tansadNo"));
                const data = {
                    ...form.bkngVrfnRslt.getValues(),
                    osceComnInscRsltReqDto: {
                        osceComnAsnmtRDto: { ...form.bkngVrfnRslt.getValues() },
                        osceComnInscAtcmDtoList: inscAtcmList,
                    },
                };

                if (type === "save") {
                    modal.openModal({
                        content: "msg.osc.00090",
                        onConfirm: () => {
                            data.osceComnInscRsltReqDto.osceComnAsnmtRDto.reffId = paramData?.tansadNo;
                            fetch.saveBkngAppAprvRslt.fetch(data);
                        },
                    });
                } else if (type === "sbmt") {
                    modal.openModal({
                        content: "msg.osc.00092",
                        onConfirm: () => {
                            data.osceComnInscRsltReqDto.osceComnAsnmtRDto.reffId = paramData?.tansadNo;
                            fetch.sbmtBkngAppAprvRslt.fetch(data);
                        },
                    });
                }
            }
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_INSC_RSTS"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group.Section>
                            <Group.Row>
                                <Group.Label {...form.bkngInfo.schema.tansadNo} />
                                <Group.Field size={4}>
                                    <Group.Control {...form.bkngInfo.schema.cstmOfceCd} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bkngInfo.schema.tansadYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bkngInfo.schema.tansadSrno} />
                                </Group.Field>
                                <Group.Label {...form.bkngInfo.schema.reffNo}></Group.Label>
                                <Group.Field size={10}>
                                    <Group.Control {...form.bkngInfo.schema.reffTin} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bkngInfo.schema.reffYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.bkngInfo.schema.reffSrno} />
                                </Group.Field>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bkngInfo.schema.blNo} />
                                <Group.Control {...form.bkngInfo.schema.bkngRqstDt} />
                            </Group.Row>
                            {/* <Group.Row>
                                <Group.Control {...form.bkngInfo.schema.bkngMdfyRqstDt} />
                            </Group.Row> */}
                            <Group.Row>
                                <Group.Control
                                    {...form.bkngVrfnRslt.schema.prcssStatCd}
                                    controlSize={10}
                                    excludes={[...excludeAuditCode]}
                                />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bkngVrfnRslt.schema.prcssRsnCn} controlSize={10} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bkngVrfnRslt.schema.rmrk} controlSize={10} />
                            </Group.Row>
                        </Group.Section>
                    </Layout>
                    {!viewOnly && (
                        <Layout direction="row">
                            <Layout.Right>
                                <Button
                                    role="save"
                                    onClick={() => {
                                        handler.validateRgstVrfnRslt("save");
                                    }}
                                />
                                {sbmtVisible && (
                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            handler.validateRgstVrfnRslt("sbmt");
                                        }}
                                    >
                                        {t("L_CFRM")}
                                    </Button>
                                )}
                            </Layout.Right>
                        </Layout>
                    )}
                    {/* {atcmVisible && ( */}
                    <Layout direction="col">
                        <Layout>
                            <Group.Title title={"T_ATCM"} titleSize={2}></Group.Title>
                            {!viewOnly && (
                                <Layout direction="row">
                                    <Layout.Left></Layout.Left>
                                    <Layout.Right>
                                        <Button
                                            role="gridAdd"
                                            onClick={() => {
                                                handler.click_Btn_AddGridList();
                                            }}
                                        ></Button>
                                        <Button
                                            role="gridDelete"
                                            onClick={() => {
                                                handler.click_Btn_DeleteGridList();
                                            }}
                                        ></Button>
                                    </Layout.Right>
                                </Layout>
                            )}
                        </Layout>
                        <Group>
                            <Group.Body>
                                <Grid {...grid.jntInscAtcm.grid} data={atcmList} render={render.grid_jntInscAtcmLst} />
                            </Group.Body>
                        </Group>
                    </Layout>
                    {/* )} */}
                </Group.Body>
            </Group>
        </Page>
    );
};
